<template>
    <div class="data-authority-settings">
        <el-form :inline="true" size="small" :model="dataForm" @keyup.enter.native="getDataList()">
            <el-form-item label="实体表名:">
                <el-input size="small" v-model="dataForm.key" placeholder="实体表名" clearable></el-input>
            </el-form-item>
            <el-form-item label="业务名称:">
                <el-input size="small" v-model="dataForm.key" placeholder="业务名称" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button>
                <el-button size="small" type="primary" name="but_add"
                           @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新增
                </el-button>
            </el-form-item>
        </el-form>
        <el-table :data="dataList" class="eltable" v-loading="dataListLoading" size="small" :height=documentClientHeight
                  @selection-change="selectionChangeHandle" style="width: 100%;">
            <el-table-column type="selection" header-align="center" align="center" width="50">
            </el-table-column>
            <el-table-column prop="roleId" header-align="center" align="center" width="50" v-if="false" label="ID">
            </el-table-column>
            <el-table-column type="index" label="序号" header-align="left" align="left" width="50">
            </el-table-column>
            <el-table-column prop="roleName" header-align="left" align="left" width="150" label="业务名称">
            </el-table-column>
            <el-table-column prop="code" header-align="left" align="left" width="150" label="实体表名">
            </el-table-column>
            <!--<el-table-column prop="tenant" header-align="left" align="left" min-width="100" show-overflow-tooltip=true label="租户">-->
            <!--</el-table-column>-->
            <el-table-column header-align="left" align="left" min-width="180" label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small"
                               @click="addOrUpdateHandle(scope.row.roleId)" icon="el-icon-edit">
                        编辑实体
                    </el-button>
                    <el-button type="text" size="small"
                               @click="deleteHandle(scope.row.roleId)" icon="el-icon-delete">
                        删除实体
                    </el-button>
                    <el-button type="text" size="small"
                               @click="positionAuthUpdateHandle(scope.row.roleId)" icon="el-icon-key">
                        查询权限
                    </el-button>
                    <el-button type="text" size="small"
                               @click="positionAuthUpdateHandle(scope.row.roleId)" icon="el-icon-key">
                        修改权限
                    </el-button>
                    <el-button type="text" size="small"
                               @click="positionAuthUpdateHandle(scope.row.roleId)" icon="el-icon-key">
                        删除权限
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
                       :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
        <Position-Auth-update v-if="positionAuthUpdateVisible" ref="positionAuthUpdate"></Position-Auth-update>
    </div>
</template>

<script>
    import AddOrUpdate from './biz-data-add-or-update'
    import PositionAuthUpdate from './position-auth-update'

    export default {
        data() {
            return {
                documentClientHeight: document.documentElement['clientHeight'] - 220,
                dataForm: {
                    roleName: ''
                },
                tenantList: [],
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false,
                positionAuthUpdateVisible: false
            }
        },
        components: {
            AddOrUpdate,
            PositionAuthUpdate
        },
        activated() {
            this.getDataList()
        },
        methods: {
            settingDataAuthorityHandler(id) {
                this.datasetauthority = true
                this.$nextTick(() => {
                    this.$refs.ataAuthority.init(id)
                })
            },
            // 获取数据列表
            getDataList() {
                this.dataList = [{
                    roleName: '审批单',
                    code: 'ApproveForm'
                }]
                //TODO
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                this.getDataList()
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            // 新增 / 修改
            addOrUpdateHandle(id) {
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(id)
                })
            },
            positionAuthUpdateHandle(id) {
                this.positionAuthUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.positionAuthUpdate.init(id)
                })
            },
            // 删除
            deleteHandle(id) {
                let ids = id ? [id] : this.dataListSelections.map(item => {
                    return item.id
                })
                this.$confirm(`确定进行${id ? '删除' : '批量删除'}操作?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //TODO
                    console.log(ids)
                }).catch(() => {
                })
            }
        }
    }
</script>
